import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Navbar from './components/Layouts/Navbar'; // votre Navbar conservée
import ProtectedRoute from './ProtectedRoute';
import AppLayout from './components/Layouts/AppLayout';

import HomePage from './components/HomePage';
import BroadcastsPage from './components/Broadcasts/Page';
import BroadcastsPage2 from './components/Broadcasts/Page2';
import AIBroadcastPage from './components/AI/AIBroadcastPage';
import AuthPage from './components/Auth/Page';
import CadastreCommunesMap from './components/Maps/LocalSearchOpen';
import CreatePlaylistPage from './pages/CreatePlaylistPage';
import ProvidersPage from './pages/ProvidersPage'; // petit wrapper simple si pas déjà créé
import BounceMonitor from './components/Stats/BounceMonitor';
import { Dashboard as BroadcastDashboard } from './components/Broadcasts';
import PackagedProductsPage from './pages/PackagedProductsPage';
import UnsubscribesPage from './pages/UnsubscribesPage';
import GestionPage from './pages/GestionPage';

function App() {
  return (
    <Router>
      <Navbar />{' '}
      {/* reste en haut, au-dessus du header global si vous le souhaitez */}
      <ToastContainer />
      <Routes>
        {/* publique */}
        <Route path="/hello" element={<AuthPage />} />

        {/* protégé */}
        <Route element={<ProtectedRoute />}>
          {/* toutes ces routes sous AppLayout → header global partout */}
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomePage />} />

            {/* Playlists/Broadcasts */}
            <Route
              path="/broadcasts/playlists/:playlistId"
              element={<BroadcastsPage />}
            />
            <Route
              path="/broadcasts/playlists/:playlistId/broadcasts/:broadcastId"
              element={<BroadcastsPage />}
            />
            <Route
              path="/broadcasts/playlists/:playlistId/broadcasts2/:broadcastId"
              element={<BroadcastsPage2 />}
            />
            <Route
              path="/broadcasts/playlists/:playlistId/broadcasts/:broadcastId/ai"
              element={<AIBroadcastPage />}
            />

            {/* Providers */}
            <Route path="/providers" element={<ProvidersPage />} />

            {/* Page création (plus de modal ni overlay) */}
            <Route path="/playlists/new" element={<CreatePlaylistPage />} />

            {/* Si vous voulez garder votre ancienne route map : */}
            <Route
              path="/maps/local-search-open"
              element={<CadastreCommunesMap />}
            />
            <Route path="/stats/bounces" element={<BounceMonitor />} />
            <Route path="/products" element={<PackagedProductsPage />} />
            <Route path="/gestion" element={<GestionPage />} />
            <Route path="/admin/unsubscribes" element={<UnsubscribesPage />} />
            <Route
              path="/broadcasts/dashboard"
              element={<BroadcastDashboard />}
            />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
